export var focusContent = function () {
    var _a, _b;
    var focusEls = (_b = (_a = document
        .getElementById('mainContent')) === null || _a === void 0 ? void 0 : _a.getElementsByClassName('content-area')[0]) === null || _b === void 0 ? void 0 : _b.querySelectorAll("a[href], area[href], input:not([disabled]), select:not([disabled]),\n      textarea:not([disabled]), button:not([disabled]), [tabindex=\"0\"]");
    (focusEls === null || focusEls === void 0 ? void 0 : focusEls[0]) && focusEls[0].focus();
};
